import React, {Component} from 'react';
import './GeneralCheckPopup.css';
import Popup from "../popup/Popup";
import GeneralCheckPage from "../../pages/generalCheckPage/GeneralCheckPage";

export default class GeneralCheckPopup extends Component {
	close = () => {
		window.popupController.hide(GeneralCheckPopup);
	};

	render(){
    return(
			<Popup
				onPopupBeforeDestroy={this.close}
				onPopupClose={this.close}
				tabletFullscreen
				opened={this.props.opened}
				className="g-general-check-popup"
			>
  		<GeneralCheckPage generalCheckId={this.props.generalCheckId} name={this.props.name} onBackClick={this.close}/>
    </Popup>
    )
  }
}